import { render, staticRenderFns } from "./FallbackLinks.vue?vue&type=template&id=65f46ff0&scoped=true&"
import script from "./FallbackLinks.vue?vue&type=script&lang=js&"
export * from "./FallbackLinks.vue?vue&type=script&lang=js&"
import style0 from "./FallbackLinks.vue?vue&type=style&index=0&id=65f46ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f46ff0",
  null
  
)

export default component.exports